<template>
  <div class="cascade-region">
    <cascader-field
      v-for="(item, index) in cascaderFields"
      :key="item.key"
      :value="item.value"
      :is-transition="index !== 0"
      placeholder="请选择"
      @click="onClickField(index)"
    />
    <van-popup :close-on-click-overlay="false" ref="popup" v-model="popupFlag" round position="bottom">
      <van-picker
        show-toolbar
        :columns="currentColumn.children || []"
        @cancel="onCancel"
        @confirm="onConfirm"
        value-key="content"
        class="cascader-picker"
      >
        <template v-slot:option="scope">
          <div class="custom-picker-item">
            <span>{{ scope.regionName }}</span>
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import CascaderField from '@/questions/cascader/CascaderField'

let _ck = 0
export default {
  name: 'CascadeRegion',
  components: { CascaderField },
  changeExpr: 'issue.answerValue',
  data() {
    return {
      cascaderFields: [],
      popupFlag: false,
      currentColumn: {},
      popGroups: [],
      cascadeOptions: [],
      value: []
    }
  },
  created() {
    this.issue.getCascade().then(res => {
      this.cascadeOptions = res
      this.initCascader()
    })
  },
  methods: {
    initCascader() {
      if (this.cascaderFields.length) return
      this.cascaderFields.push({
        children: this.cascadeOptions,
        key: _ck++,
        optionId: '',
        value: ''
      })
    },
    onClickField(index) {
      const current = (this.currentColumn = this.cascaderFields[index])
      if (!this.currentColumn.children.length) {
        const item = this.cascaderFields[index - 1]
        if (index === 0) {
          current.children = this.cascadeOptions
        } else {
          this.$bus.openLoading()
          this.issue.getCascade(item.optionId).then(data => {
            current.children = data
            this.$bus.closeLoading()
            this.popupFlag = true
          })
        }
      } else {
        this.popupFlag = true
      }
    },
    onCancel() {
      this.popupFlag = false
    },
    onConfirm(item, index) {
      // 得到当前编辑的是那一项
      let idx = this.cascaderFields.findIndex(item => item === this.currentColumn)
      if (idx === this.cascaderFields.length - 1) {
        // 如果是编辑的最后一项 并且不能只有一项 什么都不做
      } else {
        // 如果和当前选择内容一致 什么都不做
        if (this.currentColumn.optionId === item.regionCode) {
          this.popupFlag = false
          return
        } else {
          this.cascaderFields.splice(idx + 1)
        }
      }
      this.currentColumn.optionId = item.regionCode
      this.currentColumn.value = item.regionName
      if (item.next) {
        this.issue.getCascade(item.regionCode).then(data => {
          this.cascaderFields.push({
            children: data,
            key: _ck++,
            optionId: '',
            value: ''
          })
          this.popupFlag = false
          this.issue.error = '请选择完整选项'
        })
      } else {
        this.issue.error = null
        this.buildAnswerContent()
        this.popupFlag = false
      }
    },
    buildAnswerContent() {
      let results = []
      this.cascaderFields.forEach(item => {
        results.push({
          optionId: item.optionId,
          value: item.value,
          rowId: '',
          colId: ''
        })
      })
      this.issue.answerValue = results
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.issue.answerValue.length) {
        const cascaderFields = this.issue.answerValue.map(item => {
          return {
            key: _ck++,
            value: item.value,
            optionId: item.optionId,
            children: []
          }
        })
        this.cascaderFields = cascaderFields
      }
    })
  }
}
</script>
